/**
 * Normalized flow snapshot for comparing draft vs live (dirty flag).
 * Keys are sorted recursively so ordering differences do not false-mark dirty.
 */

import type { VoluumFlowUpdate } from '@trafficpulse/shared';

import { hydrateFlowPathAiSplit } from '@/features/flow-optimizer/tabs/standard/v2/utils/path-ai';

function stableStringifyJson(value: unknown): string {
  if (value === null) return 'null';
  const kind = typeof value;
  if (kind === 'string' || kind === 'number' || kind === 'boolean') {
    return JSON.stringify(value);
  }
  if (Array.isArray(value)) {
    const parts = value.map((item) => stableStringifyJson(item));
    return `[${parts.join(',')}]`;
  }
  if (kind === 'object') {
    const obj = value as Record<string, unknown>;
    const keys = Object.keys(obj).sort();
    const parts = keys.map(
      (k) => `${JSON.stringify(k)}:${stableStringifyJson(obj[k])}`,
    );
    return `{${parts.join(',')}}`;
  }
  return JSON.stringify(value);
}

export function flowSnapshotForDirtyCompare(flow: VoluumFlowUpdate): string {
  const c = JSON.parse(JSON.stringify(flow)) as VoluumFlowUpdate;
  hydrateFlowPathAiSplit(c);
  return stableStringifyJson(c);
}
